import { UNIT_MEASURE } from '@common/constants';
import { ProductType } from '@common/enums';
import formatUOM from '@common/helpers/formatUOM';
import { PricedProduct } from '@common/models';

export function getUnitType(priceItem: PricedProduct): string {
    if (priceItem.unitOfMeasure) {
        // This will use the unitOfMeasure from the database if it's available
        return formatUOM(priceItem.unitOfMeasure);
    }

    // if no UOM in the priced product, use the old, predefined method
    // implement as its own function so we don't have to format each return
    const pickUnit = (productType: ProductType) => {
        switch (productType) {
            case ProductType.EDGE:
                return UNIT_MEASURE.EDGE;
            case ProductType.CORNER_RADIUS:
                return UNIT_MEASURE.CORNER_RADIUS;
            case ProductType.CUTOUT:
                return UNIT_MEASURE.CUTOUT;
            case ProductType.DISHWASHER:
                return UNIT_MEASURE.DISHWASHER;
            case ProductType.REFRIGERATOR:
                return UNIT_MEASURE.REFRIGERATOR;
            case ProductType.SINK:
                return UNIT_MEASURE.SINK;
            case ProductType.SINK_LABOR:
                return UNIT_MEASURE.SINK_LABOR;
            case ProductType.FAUCET:
                return UNIT_MEASURE.FAUCET;
            case ProductType.LABOR:
                return UNIT_MEASURE.LABOR;
            case ProductType.COOKING_APPLIANCE:
                return UNIT_MEASURE.COOKING_APPLIANCE;
            case ProductType.TEAR_OUT:
                return UNIT_MEASURE.TEAR_OUT;
            case ProductType.WARRANTY:
                return UNIT_MEASURE.WARRANTY;
            case ProductType.CUSTOM_WORK:
                return UNIT_MEASURE.CUSTOM_WORK;
            case ProductType.JOINT_POINT:
                return UNIT_MEASURE.JOINT_POINT;
            case ProductType.OVERSIZE_FEE:
                return UNIT_MEASURE.OVERSIZE;
            case ProductType.DIAGONAL:
                return UNIT_MEASURE.DIAGONAL_CORNER;
            case ProductType.OTHER:
                return UNIT_MEASURE.NONE; // safer to ignore the unit in this case
            default:
                // this will catch COUNTERTOPs, which can have various values
                return UNIT_MEASURE.MATERIALS;
        }
    };

    return formatUOM(pickUnit(priceItem.productType));
}
